<template>
<footer class="headfoot simple-footer">
  <div class="simple-footer__inner-wrap">
    <div class="simple-footer__inner">
      <a target="_blank" href="https://www.his-j.com/Default.aspx" class="simple-footer__logo simple-footer__logo--his" rel="noopener"></a>
      <div class="simple-footer__menu-wrap">
        <ul class="simple-footer__menu">
          <li><a href="http://www.his.co.jp/">会社案内・IR情報・プレスリリース</a></li>
          <li><a href="https://www.his.co.jp/en/">About HIS (English)</a></li>
          <li><a href="https://www.his.co.jp/global/japan/">採用情報</a></li>
          <li><a href="https://www.his-j.com/company/yakkan/">旅行業約款・条件書</a></li>
          <li><a href="https://www.his.co.jp/privacy/">個人情報保護方針</a></li>
        </ul>
        <div class="simple-footer__privacy">
        <a target="_blank" href="https://www.his-j.com/jump/?34" class="simple-footer__logo simple-footer__logo--privacy" rel="noopener"></a>
        </div>
      </div>
    </div>
    <p class="simple-footer__copyright"><small>Copyright © HIS Co.,Ltd. All Rights Reserved.</small></p>
  </div>
</footer>
</template>
<script>
export default {
}
</script>
<style scoped>
.simple-footer__menu a:focus {
  text-decoration: underline;
}
@media screen and (min-width: 992px) {
  .simple-footer__menu a:hover {
    text-decoration: underline;
  }
}
@media screen and (max-width: 767px) {
  .simple-footer__menu a:hover,
  .simple-footer__menu a:focus {
    text-decoration: underline;
  }
}
.simple-footer {
  position: relative;
  background: #fff;
  border-top: 4px solid #0057B8;
}

.simple-footer__inner-wrap {
  position: relative;
}

.simple-footer__menu-wrap {
  display: flex;
  justify-content: space-between;
}

.simple-footer__menu {
  list-style-type: none;
  font-size: 14px;
  line-height: 22px;
  flex-grow: 1;
  text-align: left;
}

.simple-footer__menu a {
  color: #333;
  text-decoration: none;
}

.simple-footer__logo {
  display: block;
  background-repeat: no-repeat;
}

.simple-footer__logo--his {
  background: url(https://www.his-j.com/cmn/images/his_logo_blue.svg) no-repeat center;
}

.simple-footer__logo--privacy {
  background: url(https://www.his-j.com/cmn/images/privacy.png) no-repeat center;
  flex-shrink: 0;
}

.simple-footer__privacy {
  display: flex;
  flex-direction: column;
}

.simple-footer__copyright {
  font-family: 'Noto Sans';
  font-size: 12px;
  color: #888;
  display: flex;
}

.simple-footer__page-top {
  position: absolute;
  right: 24px;
  top: -32px;
  font-size: 12px;
  color: #6a6a6a;
  text-decoration: none;
}

.simple-footer__page-top::after {
  content: '';
  display: inline-block;
  width: 12px;
  height: 7px;
  background: url(https://www.his-j.com/cmn/n-headfoot/images/arrow_top_gray.svg) no-repeat;
  margin-left: 7px;
}

.simple-footer__inner-wrap {
  max-width: 1024px;
  padding: 22px 16px 16px;
  margin-left: auto;
  margin-right: auto;
}

.simple-footer__inner {
  display: flex;
}

.simple-footer__menu-wrap {
  flex-direction: row-reverse;
  align-items: flex-start;
  flex-grow: 1;
  margin-top: 0;
  padding-left: 10px;
}

.simple-footer__menu {
  padding-left: 16px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.simple-footer__menu > * + * {
  margin-top: 0;
}

.simple-footer__menu > * + *::before {
  content: '';
  width: 1px;
  height: 14px;
  border-left: 1px solid #333;
  margin-left: 10px;
  margin-right: 9px;
  display: inline-block;
  position: relative;
  top: 2px;
}

.simple-footer__logo--his {
  flex-shrink: 0;
  width: 68px;
  height: 27px;
  background-size: 68px auto;
  margin-top: 4px;
}

.simple-footer__logo--privacy {
  width: 40px;
  height: 40px;
  background-size: 40px auto;
  position: relative;
  top: -5px;
}

.simple-footer__copyright {
  justify-content: flex-end;
  margin: 0;
  position: absolute;
  right: 16px;
  bottom: 16px;
}

.simple-footer__privacy {
  justify-content: normal;
  padding-left: 0;
}
@media screen and (max-width: 1023px) {
  .simple-footer__inner-wrap {
    width: auto;
  }
  .simple-footer__copyright {
    position: static;
    justify-content: center;
    margin: 16px 0 0;
  }
}
@media screen and (max-width: 767px) {
  .simple-footer {
    border-width: 3px;
  }

  .simple-footer__inner-wrap {
    padding: 26px 24px 30px;
  }
  .simple-footer__inner {
    display: block;
  }

  .simple-footer__menu-wrap {
    margin-top: 21px;
    padding-left: 0;
  }
  .simple-footer__menu {
    display: block;
    padding-left: 0;
  }
  .simple-footer__menu > * + * {
    margin-top: 10px;
  }
  .simple-footer__menu > * + *::before {
    display: none;
  }

  .simple-footer__privacy {
    display: none;
    justify-content: flex-end;
    padding-left: 5px;
  }
}
</style>
